
import { throwError as observableThrowError, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';

@Injectable()
export class PackageService {
    constructor(private http: Http) { }
    isAvailable(): any {
        return this.http.head(`${environment.api.elasticSearch}`).pipe(
            map(() => true)
        ).toPromise();
    }

    searchResult(query: any): any {
        let baseUrl = `${environment.api.elasticSearch}`.replace(/\/?$/, '/');
        let url = baseUrl + encodeURIComponent(query.index) + "/_search?size=" + encodeURIComponent(query.size);
        let headers = new Headers();
        headers.set('Content-Type', 'application/json');
        let options = new RequestOptions({ headers: headers });
        return this.http.post(url, JSON.stringify(query.body), options).pipe(
            map((response: Response) => response.json())
        ).toPromise();
    }

    getPackages(customerId: string, provState: string, country: string, type: string, size: number): Observable<any> {
        let url = `${environment.api.serviceurl}` + "GetPackage?customerid=" + customerId + "&country=" + country + "&provstate=" + provState + "&type=" + type + "&size=" + size;;

        return this.http.get(url).pipe(
            map((response: Response) => {

                let pacData = response.json();
                let t = pacData.GetPackageResult;

                if (t.indexOf('null data') != -1) {
                    return [];
                }
                let p = ('(' + t + ')');
                let s = eval(p);
                return s;
            }));
    }

    getpackages(customerId: string, provState: string, country: string, type: string, size: number, sKey: string, isEnvelope: string = "N"): Observable<any> {
        let url = `${environment.api.serviceurl}` + "getPackage";
        let orderData = { "customerid": customerId, "country": country, "provstate": provState, "type": type, "size": size, "isEnvelope": isEnvelope};
        let headers = new Headers();
        headers.set('Content-Type', 'application/json');
        headers.set("authinfo", sKey);
        let data = JSON.stringify(orderData);
        let options = new RequestOptions({ headers: headers });
        return this.http.post(url, data, options).pipe(
            map(this.extractData),
            catchError(this.handleError),);
    }

    geomValidate(customerId: string, geom: string, sKey: string): Observable<any> {
        let url = `${environment.api.serviceurl}` + "geomValidate";
        let orderData = { "customerid": customerId, "stringData": geom };
        let headers = new Headers();
        headers.set('Content-Type', 'application/json');
        headers.set("authinfo", sKey);
        let data = JSON.stringify(orderData);
        let options = new RequestOptions({ headers: headers });
        return this.http.post(url, data, options).pipe(
            map(this.extractdata),
            catchError(this.handleError),);
    }

    isValidGeometryFile(customerId: string, fileUrl: string): Observable<any> {
        let url = `${environment.api.url}`;
        let orderData = { "PROCEDURE": "isValidGeometryFile", "CUSTOMER_ID": customerId, "FILE_URL": fileUrl };
        let data = JSON.stringify(orderData);

        return this.http.post(url, data).pipe(
            map(res => res.json()),
            catchError(this.handleError),
        );
    }

    getparcel(region: string, id: string): Observable<any> {
        let url = `${environment.api.getParcelUrl}`;
        let orderData = { "client": 'u13D5sq6va', "v": "4", "region": region, "parcel_id": id };
        let headers = new Headers();
        headers.set('Content-Type', 'application/json');
        let data = JSON.stringify(orderData);
        let options = new RequestOptions({ headers: headers });
        return this.http.post(url, data, options).pipe(
            map(this.extractParcelInfo),
            catchError(this.handleError),);
    }

    validateUploadGeometry(inputData: any, customerId: string): Observable<any> {
        let url = `${environment.api.url}`;
        let fixFormat = []
        inputData["GEOMETRY"].forEach(element => {
            fixFormat.push(JSON.parse(element)[0])

        });
        let orderData = { "PROCEDURE":"v2_validateWebOrderFormGeometry", "GEOMETRY": fixFormat, "CUSTOMER_ID": customerId};
        let data = JSON.stringify(orderData);
        return this.http.post(url, data).pipe(
            catchError(this.handleError),);
    }


    getprescreen(CusID: string, SeshID: string, GeoType: string, Geometry: any, Country:any, Address: string, ProvState: string) : Observable<any>{
        let url = `${environment.api.url}`;
        let orderData;
        if(Address == "" || Address == null){
            orderData = { "PROCEDURE":"getPrescreen", "CUSTOMER_ID": CusID, "SESSION_ID": SeshID, "GEOMETRY_TYPE": GeoType , "GEOMETRY": Geometry, "COUNTRY": Country, "PROVSTATE": ProvState}; //add Geometry
        }
        else{
            orderData = { "PROCEDURE":"getPrescreen", "CUSTOMER_ID": CusID, "SESSION_ID": SeshID, "GEOMETRY_TYPE": GeoType , "GEOMETRY": Geometry, "COUNTRY": Country, "ADDRESS": Address, "PROVSTATE": ProvState}; //add Geometry
        }
        let data = JSON.stringify(orderData);
        return this.http.post(url, data).pipe(
            catchError(this.handleError),);
    }

    getPreScreenMapKeyInfo(CusID: string, SeshID: string, PRESCREEN_ID: string, MapKey: string): Observable<any> {
        let url = `${environment.api.url}`;
        let orderData = { "PROCEDURE":"getPrescreenMapKeyInfo", "CUSTOMER_ID": CusID, "SESSION_ID": SeshID, "PRESCREEN_ID": PRESCREEN_ID, "MAP_KEY": MapKey };
        let data = JSON.stringify(orderData);
        return this.http.post(url, data).pipe(
            catchError(this.handleError),);
    }

    getPreScreenRecordDetails(CusID: string, SeshID: string, PRESCREEN_ID: string, DataID: any): Observable<any> {
        let url = `${environment.api.url}`;
        let orderData = { "PROCEDURE":"getPrescreenRecordDetails", "CUSTOMER_ID": CusID, "SESSION_ID": SeshID, "PRESCREEN_ID": PRESCREEN_ID, "ERIS_DATA_ID": DataID };
        let data = JSON.stringify(orderData);
        return this.http.post(url, data).pipe(
            catchError(this.handleError),);
    }

    getExcel(CusID: string, SeshID: string, GeoType: string, Geometry: any, DataIDs: any, Country:any , id:number){
        let url = `${environment.api.url}`;
        let orderData = { "PROCEDURE":"generatePrescreenExcel", "CUSTOMER_ID": CusID, "SESSION_ID": SeshID, "GEOMETRY_TYPE": GeoType , "GEOMETRY": Geometry, "ERIS_DATA_IDS":DataIDs, "COUNTRY": Country, "PRESCREEN_ID":id };
        let data = JSON.stringify(orderData);
        return this.http.post(url, data).pipe(
            catchError(this.handleError),);
    }

    getExcelHistory(CusID: string, SeshID: string){
        let url = `${environment.api.url}`;
        let orderData = { "PROCEDURE":"getPrescreenFiles", "CUSTOMER_ID": CusID, "SESSION_ID": SeshID};
        let data = JSON.stringify(orderData);
        return this.http.post(url, data).pipe(
            catchError(this.handleError),);
    }

    getPSPDF(CusID: string, SeshID: string, SearchID: string, ImageInfo: string){
        let url = `${environment.api.serviceurl}` + "GeneratePSReport";
        let orderData = { "searchid": SearchID, "customerid": CusID, "seshid": SeshID, "imageinfo": ImageInfo};
        let headers = new Headers();
        headers.set('Content-Type', 'application/json');
        headers.set("authinfo", SeshID);
        let data = JSON.stringify(orderData);
        let options = new RequestOptions({ headers: headers });
        return this.http.post(url, data, options).pipe(
            //map(this.extractdata),
            catchError(this.handleError),);
    }

    private extractData(res: Response) {
        let body = res.json();
        if (body.status == "OK") {
            let jsonbody = JSON.parse(body.orderid);
            return jsonbody || {};
        } else {
            observableThrowError(body.message);
            return []
        }
    }

    private extractdata(res: Response) {
        let body = res.json();
        if (body.status == "OK") {
            let jsonbody = body.orderid;
            return jsonbody;
        } else {
            observableThrowError(body.message);
            return []
        }
    }

    private extractParcelInfo(res: Response) {
        let body = res.json();
        if (body.status == "OK") {
            return body;
        } else {
            observableThrowError(body.message);
            return []
        }
    }

    private handleError(error: any) {
        let errMsg = '';
        if (error.message) {
            errMsg = error.message;
        } else {
            errMsg = error.status ? '${error.status} - ${error.statusText}' : 'Server error';
        }
        return observableThrowError(errMsg);
    }
}
